// extracted by mini-css-extract-plugin
export var footer = "_o5-5";
export var fulfillmentInput = "_o5-0";
export var shipDateInput = "_o5-1";
export var shipmentModal = "_o5-2";
export var shipmentModalContent = "_o5-3";
export var tableContainer = "_o5-4";